import leeCoreLexExperiments from 'bundles/epic/clients/leeCoreLex';

export function isHlsEnabled() {
  const isHlsEnabledForInCourseVideoPlayer = leeCoreLexExperiments.get('enableHlsOnInCourseVideoPlayer');
  return isHlsEnabledForInCourseVideoPlayer;
}

export function areVideoChaptersEnabled() {
  const areVideoChaptersEnabledForInCourseVideoPlayer = leeCoreLexExperiments.get('enableVideoChapters');
  return areVideoChaptersEnabledForInCourseVideoPlayer;
}
